import { useState, useRef, useMemo, useEffect, forwardRef, useImperativeHandle } from 'react';
import JoditEditor from 'jodit-react';

interface MyEditorProps {
    placeholder?: string;
    defaultValue?: string;
    setCallBack?: (value: string) => void;
    disabled?: boolean;
}

const MyEditor = forwardRef<any, MyEditorProps>(({ placeholder, defaultValue, setCallBack, disabled = false }, ref) => {
    const editor = useRef<any | null>(null);
    const [content, setContent] = useState(defaultValue || '');
    const prevContentRef = useRef(content);

    useImperativeHandle(ref, () => ({
        focus: () => {
            editor.current?.focus();
        }
    }));

    const config = useMemo(
        () => ({
            readonly: disabled,
            placeholder: placeholder || 'Start typings...',
            height: 300,
            toolbarAdaptive: false,
            buttons: [
                'bold', 'italic', 'underline', '|',
                'ul', 'ol', '|',
                'link', 'source'
            ],
        }),
        [placeholder, disabled]
    );

    useEffect(() => {
        if (defaultValue !== undefined && defaultValue !== content) {
            setContent(defaultValue);
            prevContentRef.current = defaultValue;
        }
    }, [defaultValue]);

    useEffect(() => {
        if (setCallBack && content !== prevContentRef.current) {
            prevContentRef.current = content;
            setCallBack(content);
        }
    }, [content]);

    return (
        <JoditEditor
            ref={editor}
            value={content}
            config={config}
            tabIndex={1}
            onBlur={newContent => {
                if (newContent !== content) {
                    setContent(newContent);
                }
            }}
            onChange={newContent => {
                setContent(newContent);
            }}
        />
    );
});

MyEditor.displayName = "MyEditor"

export default MyEditor;
